'use client'

import { WifiOff } from 'lucide-react'
import { useAppSession } from '@/state/session/context'
import { useOnlineStatus } from '@/lib/config/online-status'
import * as React from "react";

export function OfflineBanner(): React.JSX.Element | null {
  const { session } = useAppSession()
  const { isOnline } = useOnlineStatus()
  const pendingCount = session.offlineQueue.items.length

  if (isOnline) return null

  return (
    <div 
      role="alert"
      className="sticky top-0 z-50 border-b border-status-warning/40 bg-status-warning/15 px-4 py-2 text-xs font-bold text-status-warning"
    >
      <div className="mx-auto flex w-full max-w-6xl items-center gap-2">
        <WifiOff className="size-4" aria-hidden="true" />
        <span>
          Você está offline. Algumas ações são enfileiradas para sincronizar.
          {pendingCount > 0 ? ` (${pendingCount} pendente${pendingCount === 1 ? '' : 's'})` : ''}
        </span>
      </div>
    </div>
  )
}
